/* iYos — favoritos.

   Guardados en el navegador del visitante (localStorage). No se sincronizan
   entre dispositivos ni sirven para campañas de recuperación; para eso hace
   falta una app con cuenta de cliente. El marcado y las clases son los
   mismos, así que cambiar de motor no toca el diseño. */

(function () {
  'use strict';

  const CLAVE = 'iyos:favoritos';

  function leer() {
    try {
      const raw = localStorage.getItem(CLAVE);
      return new Set(raw ? JSON.parse(raw) : []);
    } catch (e) {
      return new Set();
    }
  }

  function guardar(set) {
    try {
      localStorage.setItem(CLAVE, JSON.stringify([...set]));
    } catch (e) {
      /* modo privado o cuota llena: el botón sigue respondiendo en la sesión */
    }
  }

  function pintar(btn, activo) {
    btn.setAttribute('aria-pressed', String(activo));
    btn.setAttribute('aria-label', (activo ? 'Quitar de favoritos: ' : 'Guardar en favoritos: ') + (btn.dataset.iyosFavTitle || ''));
  }

  function sincronizar() {
    const favs = leer();
    document.querySelectorAll('[data-iyos-fav]').forEach(function (btn) {
      pintar(btn, favs.has(btn.dataset.iyosFav));
    });
    actualizarContador(favs.size);
  }

  function actualizarContador(n) {
    document.querySelectorAll('[data-iyos-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-iyos-fav]');
    if (!btn) return;

    // La tarjeta entera es un enlace: hay que frenar la navegación.
    e.preventDefault();
    e.stopPropagation();

    const favs = leer();
    const id = btn.dataset.iyosFav;
    const activo = !favs.has(id);

    activo ? favs.add(id) : favs.delete(id);
    guardar(favs);
    pintar(btn, activo);
    actualizarContador(favs.size);

    btn.classList.remove('is-latido');
    void btn.offsetWidth; // reinicia la animación aunque se pulse seguido
    btn.classList.add('is-latido');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizar);
  } else {
    sincronizar();
  }

  document.addEventListener('shopify:section:load', sincronizar);
  // Otra pestaña puede haber cambiado la lista.
  window.addEventListener('storage', function (e) {
    if (e.key === CLAVE) sincronizar();
  });
})();
